L.Viewport = L.Class.extend({
    includes: L.Mixin.Events,

    options: {
        width: 200,
        height: 200
    },

    initialize: function (options) {
        L.Util.setOptions(this, options);

        this._width = this.options.width;
        this._height = this.options.height;
    },

    addTo: function (map) {
        this.map = map;
        this._createElements();
        this.resize();
        return this;
    },

    remove: function () {
        if (this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
    },
    
    resize: function (newDimensions) {
        if (newDimensions) {
            this._width = this.options.width = newDimensions.width;
            this._height = this.options.height = newDimensions.height;
        }
        
        this.map.invalidateSize(false);
        this._render();
    },

    _createElements: function () {
        if (!!this._container)
            return;

        this._container = L.DomUtil.create("div", "leaflet-viewport-container", this.map._controlContainer);
        this._topMask = L.DomUtil.create("div", "leaflet-viewport-mask", this._container);
        this._bottomMask = L.DomUtil.create("div", "leaflet-viewport-mask", this._container);
        this._leftMask = L.DomUtil.create("div", "leaflet-viewport-mask", this._container);
        this._rightMask = L.DomUtil.create("div", "leaflet-viewport-mask", this._container);

        this.map.on("resize", this._onMapResize, this);
    },

    _onMapResize: function () {
        this._render();
    },

    _render: function () {
        var size = this.map.getSize();

        var height = Math.round((size.y - this._height) / 2);
        var width = Math.round((size.x - this._width) / 2);

        function setDimensions(element, dimension) {
            element.style.width = dimension.width + "px";
            element.style.height = dimension.height + "px";
            element.style.top = dimension.top + "px";
            element.style.left = dimension.left + "px";
            element.style.bottom = dimension.bottom + "px";
            element.style.right = dimension.right + "px";
        }

        setDimensions(this._topMask, {
            width: size.x,
            height: height,
            top: 0,
            left: 0
        });
        setDimensions(this._bottomMask, {
            width: size.x,
            height: height,
            bottom: 0,
            left: 0
        });
        setDimensions(this._leftMask, {
            width: width,
            height: size.y - (height * 2),
            top: height,
            left: 0
        });
        setDimensions(this._rightMask, {
            width: width,
            height: size.y - (height * 2),
            top: height,
            right: 0
        });
    }
});

L.viewport = function (options) {
    return new L.Viewport(options);
};
define("leaflet-viewport", function(){});

